import undefsafe from 'undefsafe'
import querystring from 'query-string'

import {
  showAlert,
  setErrorPage,
  noIndex
} from '../actions/common'
import {
  ResponseDataError,
  SearchOfflineError,
  logError
} from '../utils/errors'
import getProxyApiUrl from '../utils/getProxyApiUrl'
import axiosVerbose from '../utils/axios/axiosVerbose'
import fetchRecommendedSearchesByTermResults from '../actions/search/fetchRecommendedSearchesByTermResults'
import fetchRecommendedSearchesByCategoryResults from '../actions/search/fetchRecommendedSearchesByCategoryResults'
import { parseLocation } from '../utils/urlHelper'
import setStudioRecommendations from './search/setStudioRecommendations'
import studioRecommendationsConfig from '../../config/sites/studio-recommendations'
import {
  isCategoryOnlySearch,
  buildSearchQueryString
} from '../utils/searchQueryHelper'

const fetchSearchResults = (parsedUrl, opts) => {
  return (dispatch, getState) => {
    const parsedLocation = parseLocation({
      pathname: parsedUrl.pathname,
      query: querystring.parse(parsedUrl.search)
    })

    const currentSite = undefsafe(getState(), 'common.currentSite') || 'themeforest'
    const apiUrlPrefix = getProxyApiUrl(opts)
    const searchStringQuery = buildSearchQueryString(parsedLocation, currentSite)
    const hasItemId = parsedLocation.item_id
    const hasSearchTerm = parsedLocation.term

    let searchUrl = hasItemId
      ? `${apiUrlPrefix}/shopfront_api/search/similar?${searchStringQuery}`
      : `${apiUrlPrefix}/shopfront_api/search?${searchStringQuery}`

    dispatch(fetchSearchResultsRequest())

    if (hasSearchTerm && !hasItemId) {
      dispatch(fetchRecommendedSearchesByTermResults(
        parsedLocation.term, {
          apiUrlPrefix
        }
      ))
    }

    return axiosVerbose.get(searchUrl)
      .then(res => {
        if (res.data && res.data.matches && !res.data.error) {
          let results = Object.assign({}, res.data, {
            term: parsedLocation.term
          })

          dispatch(fetchSearchResultsSuccess(results))
          dispatch(fetchIngestedContentSuccess(res.data.searchIngestedContent))
          dispatch(setStudioRecommendations(studioRecommendationsConfig[currentSite] || {}))

          // process other types of recommendations if term is not present
          if (isCategoryOnlySearch(parsedLocation)) {
            dispatch(
              fetchRecommendedSearchesByCategoryResults(
                parsedLocation,
                results,
                currentSite
              )
            )
          }

          return dispatch(setSeoData(res.data.metadata))
        } else {
          throw ResponseDataError({response: res})
        }
      })
      .catch(err => {
        const isSearchOffline = [422, 500, 502, 503].includes(err.statusCode)
        if (isSearchOffline) {
          throw SearchOfflineError({
            statusCode: err.statusCode
          })
        }

        throw err
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(err => {
        return Promise.reject(dispatch(fetchSearchResultsFailure(err)))
      })
  }
}

/**
 * Search result actions
 */
const fetchSearchResultsRequest = () => {
  return { type: 'fetchSearchResultsRequest' }
}
const fetchSearchResultsSuccess = results => {
  return {
    type: 'fetchSearchResultsSuccess',
    payload: {
      results
    }
  }
}
const fetchSearchResultsFailure = error => {
  return (dispatch) => {
    let timeout = false

    dispatch(noIndex())

    if (error.type === 'search.offline') {
      dispatch(setErrorPage('SearchOffline'))
    } else {
      if (error.type === 'axios.timeout') {
        timeout = true
      }
      dispatch(showAlert(error.message, 'failure', false))
    }

    return dispatch({
      type: 'fetchSearchResultsFailure',
      error: true,
      httpStatus: 500,
      timeout
    })
  }
}

/**
 * IngestedContentSuccess
 */
const fetchIngestedContentSuccess = content => {
  return {
    type: 'fetchIngestedContentSuccess',
    payload: {
      content
    }
  }
}

/**
 * SEO data
 */
const setSeoData = seoMeta => {
  return {
    type: 'setSeoData',
    payload: {
      seoMeta
    }
  }
}

export const setActiveAudio = activeAudio => {
  return {
    type: 'setActiveAudio',
    payload: {
      activeAudio
    }
  }
}

export default fetchSearchResults



// WEBPACK FOOTER //
// ./common/actions/searchPage.js